import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import { Avatar } from "../../types/modules/admin/avatar.type";

export const useAvatarsByAdmin = () => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["avatars-by-admin"],
    queryFn: () => fetcher<Avatar[]>(`avatar`, token),
  });
};
